import React, { useState, useEffect, useCallback } from "react";
import { get, post, patch, del } from "../../../helpers/api_helper";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane,
  Button, Spinner, Row, Col,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const ODATA_BASE = "https://buharaapi.stechomeyazilim.info";

const LANGS = [
  { code: "en", label: "🇬🇧 English" },
  { code: "fr", label: "🇫🇷 Français" },
  { code: "de", label: "🇩🇪 Deutsch" },
  { code: "nl", label: "🇳🇱 Nederlands" },
];

export default function AboutTranslations() {
  document.title = "Hakkımızda Çevirileri | BUHARA - Admin Paneli";

  const [activeTab, setActiveTab] = useState("en");
  const [records, setRecords]     = useState({});   // { en: {ID, About_Html}, ... }
  const [htmlMap, setHtmlMap]     = useState({});   // { en: "<p>...</p>", ... }
  const [loading, setLoading]     = useState(false);
  const [saving, setSaving]       = useState(false);

  const fetchRecords = useCallback(async () => {
    setLoading(true);
    try {
      const res = await get(`${ODATA_BASE}/About_Lang`);
      const items = res?.value || [];
      const recMap = {};
      const hMap   = {};
      items.forEach(item => {
        recMap[item.Lang_Code] = item;
        hMap[item.Lang_Code]   = item.About_Html || "";
      });
      setRecords(recMap);
      setHtmlMap(hMap);
    } catch (err) {
      console.error("About_Lang fetch error:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchRecords(); }, [fetchRecords]);

  const handleSave = async (lang) => {
    setSaving(true);
    try {
      const existing = records[lang];
      const payload  = { Lang_Code: lang, About_Html: htmlMap[lang] || "" };
      if (existing?.ID) {
        await patch(`${ODATA_BASE}/About_Lang(${existing.ID})`, payload);
        toastr.success(`${lang.toUpperCase()} çevirisi güncellendi.`);
      } else {
        await post(`${ODATA_BASE}/About_Lang`, payload);
        toastr.success(`${lang.toUpperCase()} çevirisi eklendi.`);
      }
      await fetchRecords();
    } catch (err) {
      toastr.error("Kayıt sırasında hata oluştu.");
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (lang) => {
    const existing = records[lang];
    if (!existing?.ID) return;
    if (!window.confirm(`${lang.toUpperCase()} çevirisini silmek istiyor musunuz?`)) return;
    setSaving(true);
    try {
      await del(`${ODATA_BASE}/About_Lang(${existing.ID})`);
      toastr.success(`${lang.toUpperCase()} çevirisi silindi.`);
      await fetchRecords();
      setHtmlMap(prev => ({ ...prev, [lang]: "" }));
    } catch {
      toastr.error("Silme sırasında hata oluştu.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Yönetim" breadcrumbItem="Hakkımızda Çevirileri" />
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                {loading ? (
                  <div className="text-center py-5">
                    <Spinner color="warning" />
                    <span className="ms-2">Yükleniyor...</span>
                  </div>
                ) : (
                  <>
                    <Nav tabs className="mb-3">
                      {LANGS.map(l => (
                        <NavItem key={l.code}>
                          <NavLink
                            className={activeTab === l.code ? "active fw-bold" : ""}
                            onClick={() => setActiveTab(l.code)}
                            style={{ cursor: "pointer" }}
                          >
                            {l.label}
                            {records[l.code] && (
                              <span className="ms-1 badge bg-success" style={{ fontSize: 9 }}>✓</span>
                            )}
                          </NavLink>
                        </NavItem>
                      ))}
                    </Nav>

                    <TabContent activeTab={activeTab}>
                      {LANGS.map(l => (
                        <TabPane tabId={l.code} key={l.code}>
                          <p className="text-muted mb-2">
                            {l.label} — Hakkımızda HTML içeriği.
                            {records[l.code]
                              ? " (Mevcut kayıt güncelleniyor)"
                              : " (Yeni kayıt eklenecek)"}
                          </p>
                          <CKEditor
                            editor={ClassicEditor}
                            data={htmlMap[l.code] || ""}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setHtmlMap(prev => ({ ...prev, [l.code]: data }));
                            }}
                          />
                          <div className="d-flex gap-2 mt-3">
                            <Button
                              color="warning"
                              disabled={saving}
                              onClick={() => handleSave(l.code)}
                            >
                              {saving ? <Spinner size="sm" /> : null}
                              {" "}{records[l.code] ? "Güncelle" : "Kaydet"}
                            </Button>
                            {records[l.code] && (
                              <Button
                                color="danger"
                                outline
                                disabled={saving}
                                onClick={() => handleDelete(l.code)}
                              >
                                Sil
                              </Button>
                            )}
                          </div>
                        </TabPane>
                      ))}
                    </TabContent>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}
